<template>
  <div>
    <embed-api-table
      title="Social Sites"
      module="Client-Pages"
      v-bind:add-new-text="addNewText"
      @click="profileClicked"
      @add-new="addNewClicked"
      default-sort="createdAt DESC"
      v-bind:per-page="perPage"
      v-bind:columns="socialColumns"
      v-bind:filter="socialFilter"
      v-bind:refresh-for-id="refreshSocialID">
    </embed-api-table>
    
    <add-social-site @added="onSocialSiteAdded" v-bind:client-id="clientId" v-bind:refresh-id="refreshSocialDialog"></add-social-site>
    
    <div class="modal modal-blur fade" id="modal-social-table" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Social Profile Details</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
          </div>
          <div class="modal-body" v-if="socialDetails">
            Site: {{socialDetails.site}}<br />
            Email:{{socialDetails.email}} <br />
            Username: {{socialDetails.username}}<br />
            Keyword: {{socialDetails.keyword}}<br />
            Password: <span v-show="!editingPassword">{{socialDetails.password}}</span> <input v-show="editingPassword" tye="text" v-model="txtPassword" /> <button @click="changePasswordClick" class="btn btn-primary">Change</button><br />
            URL: <span v-show="!editingURL">{{socialDetails.url}}</span> <input v-show="editingURL" tye="text" v-model="txtURL" /> <button @click="changeURLClick" class="btn btn-primary">Change</button><br />
            Content: {{socialDetails.content}}<br />
            Error: {{socialDetails.error}} <button @click="toggleErrorClick" class="btn btn-primary">Toggle</button><br />
            Created: {{socialDetails.created}} <button @click="toggleCreatedClick" class="btn btn-primary">Toggle</button><br />
            Only Create After: {{socialDetails.onlyCreateAfter}}<br />
            Created At: {{socialDetails.createdAt}}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AddSocialSite from "./AddSocialSite.vue";
  import EmbedApiTable from "./EmbedApiTable.vue";
  import WebLLCRESTApi from "../api/api";
  import $ from 'jquery';
  
  export default {
    created() {
      // prepare api
      this.api = new WebLLCRESTApi("Client-Pages", this.$router);
    },
    
    props: {
      clientId: String,
      canSave: Boolean
    },
    
    data() {
      return {
        addNewText: (this.canSave ? "Add New Sites" : null),
        
        socialColumns: this.getColumns(),
        
        editingURL: false,
        editingPassword: false,
        
        txtPassword: "",
        txtURL: "",
        refreshSocialID: "0",
        refreshSocialDialog: "0",
        perPage: 10,
        
        socialDetails: null,
        
        socialFilter: { category: "socialprofile", clientId: this.clientId }
      };
    },
    
    methods: {
      addNewClicked() {
        // refresh the social dialog in case new keywords were added, we need to repull them
        this.refreshSocialDialog = Date.now().toString();
        $('#modal-add-social-site').modal('toggle');
      },
      
      async profileClicked(data) {
        if(data.col.text == "Details") {
          this.socialDetails = data.item.item;
          this.txtPassword = this.socialDetails.password,
          this.txtURL = this.socialDetails.url,
          $("#modal-social-table").modal("show");
        }
        else if(data.col.text == "Retry") {
          var updateObj = {
            error: false,
            created: false
          };
          
          var id = data.item.item.id;
          
          await this.api.updateData(id, updateObj);
          
          this.refreshSocialID = Date.now();
        }
      },
      
      async changeURLClick() {
        if(this.editingURL) {
          var updateObj = {
            url: this.txtURL
          };
          
          await this.api.updateData(this.socialDetails.id, updateObj);
          
          this.refreshSocialID = Date.now().toString();
          this.socialDetails.url = this.txtURL;
          this.editingURL = false;
        }
        else {
          this.editingURL = true;
        }
      },
      
      async changePasswordClick() {
        if(this.editingPassword) {
          var updateObj = {
            password: this.txtPassword
          };
          
          await this.api.updateData(this.socialDetails.id, updateObj);
          
          this.refreshSocialID = Date.now().toString();
          this.socialDetails.password = this.txtPassword;
          this.editingPassword = false;
        }
        else {
          this.editingPassword = true;
        }
      },
      
      async toggleErrorClick() {
        this.socialDetails.error = !this.socialDetails.error;
        
        var updateObj = {
          error: this.socialDetails.error
        };
        
        await this.api.updateData(this.socialDetails.id, updateObj);
        
        this.refreshSocialID = Date.now().toString();
      },
      
      async toggleCreatedClick() {
        this.socialDetails.created = !this.socialDetails.created;
        
        var updateObj = {
          created: this.socialDetails.created
        };
        
        await this.api.updateData(this.socialDetails.id, updateObj);
        
        this.refreshSocialID = Date.now().toString();
      },
      
      onSocialSiteAdded() {
        this.refreshSocialID = Date.now().toString();
      },
      
      getColumns() {
        const cols = [
          { key: "url", "text": "URL", type: "URL" },
          { key: "createdAt", "text": "Created", type: "Date" }
        ];
        
        if(this.canSave) {
          cols.unshift({ key: "bulkdelete", "text": "", type: "BulkDelete" });
          cols.push({ key: "delete", "text": "Delete", type: "Delete", sort: false });
        }
        
        return cols;
      }
    },
    
    watch: {
      canSave(to, from) {
        this.addNewText = (this.canSave ? "Add New Sites" : null);
        this.socialColumns = this.getColumns();
      }
    },

    components: {
      AddSocialSite,
      EmbedApiTable
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SocialTable.vue